import React from "react"

export default function Pie({
  slices,
  colors,
  background,
  dataCy,
}: {
  slices: [number, number]
  colors: [string, string]
  background: string
  dataCy: string
}) {
  const [animation, setAnimation] = React.useState(100)
  const initialDelay = React.useRef(true)
  const animateSlices = slices.map(slice => (slice / 100) * (100 - animation))

  React.useEffect(() => {
    const config = {
      delay: 400,
      framerate: 20,
    }

    const animationStep = () => {
      const t = 101 - animation
      let exp = (t * t) / 40
      if (exp > 6) exp = 6
      let step = t / 15 + exp
      setAnimation(s => (s - step < 0 ? 0 : s - step))
    }

    let delay = initialDelay.current ? config.delay : config.framerate

    if (initialDelay.current) initialDelay.current = false
    let timer = setTimeout(animationStep, delay)

    return () => clearTimeout(timer)
  })

  const starting = animateSlices.map((_, i) =>
    animateSlices.slice(0, i).reduce((t, x) => t + x, 0)
  )

  const hole = 50
  const h = 100
  const h_extra = 101

  return (
    <svg
      viewBox={`0 0 200 ${h_extra}`}
      data-cy={dataCy}
      style={
        {
          "--set-pie-background": background,
        } as React.CSSProperties
      }
    >
      {animateSlices.map((ang, i) => {
        const start = starting[i] || 0

        const a = {
          x: h - 100 * Math.cos((start / 100) * Math.PI),
          y: h_extra - 100 * Math.sin((start / 100) * Math.PI),
        }
        const b = {
          x: h - 100 * Math.cos(((ang + start) / 100) * Math.PI),
          y: h_extra - 100 * Math.sin(((ang + start) / 100) * Math.PI),
        }

        const col = colors[i % colors.length]

        return (
          <path
            key={i}
            data-index={i}
            fill={col}
            stroke={col}
            strokeWidth={0}
            d={`M ${a.x},${a.y} A 100,${h_extra},0,0,1, ${b.x},${b.y} L 100,${h_extra} Z`}
          ></path>
        )
      })}
      <path
        fill={"var(--set-pie-background,white)"}
        d={`M ${hole},${h_extra} A ${hole},${hole},0,0,1, ${
          100 + hole
        },${h_extra} L 100,${h_extra} Z`}
      ></path>
    </svg>
  )
}
